export default __webpack_public_path__ + "static/media/distance.892e1ac1.svg";